const envExample = {
    name: '未来GO',
    logo: '/images/weilaigo.jpg',
    AMap: {
        key: 'bb7c0315822c8f3eea9f946fb8169a9a'
    },
    isPosSwitch: false,//false不允许切换商户,true允许商户切换
}
export default envExample;
